<app-dialog
	modalTitle="Permissão Negada"
	titleButton="Voltar"
	[secButton]="false"
	[asAlert]="true"
	(dialogClose)="closeDialog()"
	(dialogSave)="closeDialog()"
>
	<div mat-dialog-content>
		<p>{{ data.message }}</p>
	</div>
</app-dialog>
